import { format } from "date-fns";

import { MISCELLANEOUS_OPTIONS } from "../merge-tags-options/miscellaneous.utils";
import { MergeTagsReplaceHandler } from "./merge-tags-values";

export const MISCELLANEOUS_VALUES: MergeTagsReplaceHandler = {
  [MISCELLANEOUS_OPTIONS.CURRENT_DATE]: ({ data }) => {
    return format(new Date(), "MM/dd/yyyy");
  },
  [MISCELLANEOUS_OPTIONS.CURRENT_DATE_TIME]: ({ data }) => {
    return format(new Date(), "EEEE MMMM dd, yyyy, 'at' h:mm aa");
  }
};
